import { Field, ErrorMessage } from 'formik' 
import { AiOutlineExclamationCircle } from "react-icons/ai";

const EmailInput = ({ errors, touched }) => {
  return (
    <>
        <label htmlFor='email'>Enter email</label>
        <Field 
            name="email"
            type="email"
            placeholder="example@gmail.com"
            className={errors.email && touched.email ? "input-error" : ""}
        />
        <ErrorMessage name="email">
            {msg => (
                <p className="error-msg">
                    <AiOutlineExclamationCircle />
                    <span>{msg}</span>
                </p>
            )}
        </ErrorMessage>
    </>
  )
}

export default EmailInput